<style lang='less' scoped>
.banner{position: sticky; top: 0px;}
.el-menu-demo{width: 1200px;height: 60px;margin: auto;background: none;border: none;display: flex;justify-content: space-between;}
/deep/.el-menu-item{height: 60px;border-bottom: none;}
/deep/.el-menu-item{font-size: 16px; color: #ffffff;}
/deep/.el-menu-item:hover{background-color: #0347b8 !important;color: #ffffff !important;}
/deep/.el-menu-item:focus{background: none !important;}
/deep/.el-menu--horizontal>.el-menu-item.is-active{color: #ffffff;border-bottom: none;}
</style>

<template>
  <div class="banner">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
      v-if="this.$route.path === '/PromoinApp' || this.$route.path === '/wjhg' || this.$route.path === '/chbm' || this.$route.path === '/Ltgk' || this.$route.path === '/Ltzlhgk' | this.$route.path === '/NewsListApp'">
      <el-menu-item  v-for="(item, id) in menulist" :key="id"  :index="item.sort" @click="custormAnchor(item)">{{item.namec}}</el-menu-item>
    </el-menu>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" v-else>
      <el-menu-item  v-for="(item, id) in menulist" :key="id"  :index="item.sort" @click="onRouterlink(item)">{{item.namec}}</el-menu-item>
    </el-menu>
  </div>
</template>

<!--安进 2021.6.18
    导航的判断
    当前页面为论坛资讯页面时，部分导航为描点，其他导航正常进行路由跳转，子路由页面点击描点导航返回论坛资讯页面
-->
<script>
export default {
  props:
  {
    menulist: {type: Array, default: null}
  },
  data()
  {
    return {
      activeIndex: '1'
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      let router = this.$route.name
      this.menulist.forEach(e =>
      {
        if (e.namee === router)
          this.activeIndex = e.sort
      })
    })
  },
  methods:
  {
    onRouterlink(item)
    {
      //矿业一张图打开新页面
      if (item.namee === 'Kyyztoply')
      {
        let  url = this.$router.resolve({path: '/Kyyztoply'})
        window.open(url.href, '_blank')
      }
      //数字大屏打开新页面
      else if (item.namee === 'LargeScreen')
      {
        let url = this.$router.resolve({path: '/LargeScreen'})
        window.open(url.href, '_blank')
      }
      else
        this.$router.push({name: item.namee})
    },
    custormAnchor(item)
    {
      switch (item.namec)
      {
      case '矿业论坛首页':
        this.$router.push({name: 'PromoinApp'})
        break
      case '大会新闻':
        this.$router.push({name: 'PromoinApp'})
        document.getElementById('dhxw').scrollIntoView({ block: 'start', behavior: 'smooth' })
        break
      case '会议日程':
        this.$router.push({name: 'PromoinApp'})
        document.getElementById('hyrc').scrollIntoView({ block: 'start', behavior: 'smooth' })
        break
      case '演讲嘉宾':
        this.$router.push({name: 'PromoinApp'})
        document.getElementById('yjjb').scrollIntoView({ block: 'start', behavior: 'smooth' })
        break
      case '往届回顾':
        this.$router.push({name: 'wjhg'})
        break
      case '参会报名':
        // this.$router.push({name: 'chbm'})
        window.open('https://www.camining.cn/nav/index.html', '_blank')

        break
      default:
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/layout/MenuPanelApp.vue